// extracted by mini-css-extract-plugin
export default {"attribute":"attribute--rY9+q"};